import api from "./api";
import StorageService from "./StorageService";

const ExpenditureTypeService = {
  getAll: async (page = 1, limit = 10, filters = {}) => {
    try {
      let url = `/expenditure-types?page=${page}&limit=${limit}`;
      const res = await api.get(url);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to fetch expenditure types");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  },

  getById: async (id) => {
    try {
      const res = await api.get(`/expenditure-types/${id}`);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to fetch expenditure type");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  },

  create: async (data) => {
    try {
      const payload = { ...data, createdBy: StorageService.loginData().employeeId };
      const res = await api.post("/expenditure-types", payload);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to create expenditure type");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  },

  update: async (id, data) => {
    try {
      const payload = { ...data, updatedBy: StorageService.loginData().employeeId };
      const res = await api.put(`/expenditure-types/${id}`, payload);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to update expenditure type");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  },

  updateStatus: async (id, status) => {
    try {
      const res = await api.patch(`/expenditure-types/${id}/status`, { status, updatedBy: StorageService.loginData().employeeId });
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to update expenditure type status");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  }
};

export default ExpenditureTypeService;
